import { Component, OnInit, Input, ViewChild } from '@angular/core';
import { DialogRef } from '@progress/kendo-angular-dialog';
import { FormGroup, FormBuilder, AbstractControl } from '@angular/forms';
import { DtoSupplier } from './models/DtoSupplier';
import { SettingsBaseService } from './settings-base.service';
import { FormService } from '../../../fw/services/form.service';
import { ValidationMessageComponent } from '../../shared/validation-message.component';
import { SharedValidators } from '../../shared/shared-validators';
import { SharedDataService } from '../../shared/shared-data.service';
import { Observable } from 'rxjs/Rx';
import { AutoUnsubscribe } from '../../../fw/decoractors/AutoUnsubscribe';
import { DtoCountry } from "../../shared/models/DtoCountry";
import {SharedService} from "../../shared/shared.service";
import {AsyncValidatorWrapper} from "../../../fw/helpers/async-validator-wrapper";

@Component({
    selector: 'supplier',
    template: require('./supplier.component.html'),
    styles: [require('./supplier.component.css')]
})
@AutoUnsubscribe()

export class SupplierComponent implements OnInit {
    @Input() dialog: DialogRef;
    @Input() id: number;
    @Input() copyFromId: number;
    @ViewChild('validationMessage', {static: false}) validationMessage: ValidationMessageComponent;
    form: FormGroup;
    dtoObject: DtoSupplier;
    countryItems: Array<DtoCountry>;
    correspontWithItems: Array<{ text: string, value: number }> = [
        { text: "", value: 0 },
        { text: "Bezoekadres", value: 1 },
        { text: "Postadres", value: 2 }
    ];

    constructor(private fb: FormBuilder,
                private fs: FormService,
                private ds: SettingsBaseService,
                private ss: SharedService,
                private sds: SharedDataService) { }

    ngOnInit() {
        this.form = this.fb.group({
            name: ['', [SharedValidators.customRequired]],
            index: [null,[SharedValidators.customRequired], [AsyncValidatorWrapper.debounce(this.validateIndex.bind(this))]],
            bankaccount: null,
            contactPerson: null,
            correspontWith: null,
            customerNo: null,
            email: null,
            faxNumber: null,
            invoiceText: null,
            mobileNumber: null,
            nameAddition: null,
            phoneNumber: null,
            postCity: null,
            postCountryId: null,
            postHouseNo: null,
            postStreet: null,
            postZipcode: null,
            remarks: null,
            url: null,
            visitCity: null,
            visitCountryId: null,
            visitHouseNo: null,
            visitStreet: null,
            visitZipcode: null
        });

        this.sds.getCountries().subscribe(response => this.countryItems = response);

        this.form.valueChanges.subscribe(() =>
            {if (this.validationMessage) this.validationMessage.getFormValidationErrors();}
        );

        if (this.id > 0) {
            this.ds.getSupplierById(this.id)
                .subscribe(response => {
                    this.dtoObject = response;
                    this.fs.patchDtoToForm(this.dtoObject, this.form);
                });
        }
        else {
            this.ds.getSupplierNextIndex()
                .subscribe(res => {
                    this.dtoObject = {
                        id: 0,
                        index: res
                    };
                    if (this.copyFromId > 0) {
                        this.ds.getSupplierById(this.copyFromId)
                            .subscribe(response => {
                                this.dtoObject.bankaccount = response.bankaccount;
                                this.dtoObject.contactPerson = response.contactPerson;
                                this.dtoObject.correspontWith = response.correspontWith;
                                this.dtoObject.customerNo = response.customerNo;
                                this.dtoObject.email = response.email;
                                this.dtoObject.faxNumber = response.faxNumber;
                                this.dtoObject.invoiceText = response.invoiceText;
                                this.dtoObject.mobileNumber = response.mobileNumber;
                                this.dtoObject.name = response.name;
                                this.dtoObject.nameAddition = response.nameAddition;
                                this.dtoObject.phoneNumber = response.phoneNumber;
                                this.dtoObject.postCity = response.postCity;
                                this.dtoObject.postCountryId = response.postCountryId;
                                this.dtoObject.postStreet = response.postStreet;
                                this.dtoObject.postZipcode = response.postZipcode;
                                this.dtoObject.remarks = response.remarks;
                                this.dtoObject.url = response.url;
                                this.dtoObject.visitCity = response.visitCity;
                                this.dtoObject.visitCountryId = response.visitCountryId;
                                this.dtoObject.visitHouseNo = response.visitHouseNo;
                                this.dtoObject.visitStreet = response.visitStreet;
                                this.dtoObject.visitZipcode = response.visitZipcode;
                                this.fs.patchDtoToForm(this.dtoObject, this.form);
                            });
                    }
                    else {
                        this.fs.patchDtoToForm(this.dtoObject, this.form);
                    }
                });
        }
    }

    validateIndex(control: AbstractControl) {
        return Observable.create(observer => {
            if (this.dtoObject != null && control.dirty && control.value != null) {
                this.ds.checkSupplierIndexAvailable(this.dtoObject.id, control.value)
                    .subscribe((response: boolean) => {
                        observer.next(response ? null : { indexNotAvailable: true });
                        observer.complete();
                        if (this.validationMessage) this.validationMessage.getFormValidationErrors();
                    });
            }
            else {
                observer.next(null);
                observer.complete();
                if (this.validationMessage) this.validationMessage.getFormValidationErrors();
            }
        });
    }

    btnCancelClicked(event) {
        this.closeWindow(false);
    }

    btnSaveClicked(event) {
        this.validationMessage.validateForm();

        if (this.form.valid) {
            let result = this.fs.patchFormToDto(this.dtoObject, this.form);
            this.ds.saveSupplier(result)
                .subscribe(response => {
                    if (!response.hasError) {
                        this.closeWindow(true);
                    }
                    else {
                        this.ss.message(response.errorMessage);
                    }
                });
        }
    }

    closeWindow(result: boolean) {
        if (this.dialog) {
            this.dialog.dialog.instance.action.emit(result);
            this.dialog.close();
        }
    }
}



// WEBPACK FOOTER //
// ./node_modules/angular2-template-loader!./Scripts/app/settings/settings-base/supplier.component.ts